<script lang="ts">
  export const name = 'Plus';
  export let className = '';
</script>

<svg class={className} viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0 8C0 7.44772 0.447715 7 1 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H1C0.447715 9 0 8.55228 0 8Z"
  />
  <path
    d="M7.5 15.5C6.94772 15.5 6.5 15.0523 6.5 14.5L6.5 1.5C6.5 0.947715 6.94771 0.5 7.5 0.5C8.05228 0.5 8.5 0.947715 8.5 1.5L8.5 14.5C8.5 15.0523 8.05228 15.5 7.5 15.5Z"
  />
</svg>
